const routes = [
    {
        path: '/daily/course/schedules',
        component: () => import('../pages/Index.vue'),
        meta: {
            isAuthenticated: true,
            permission: 'dailycourseschedule_index'
        }
    },
    {
        path: "/daily/course/schedules/:id",
        component: () => import("../pages/Makeup.vue"),
        meta: {
            isAuthenticated: true,
            permission: "dailycourseschedule_index"
        }
    },
];

export default routes;
